import { NgModule } from 'ng-metadata/core';
import {PrmServiceNoOfferFound} from './noOfferFound/noOfferFound.directive';
import {PrmServicePhysicalBestOffer} from './physicalBestOffer/physicalBestOffer.directive';
import {PrmServiceNgrs} from './ngrs.directive';
import {PhysicalBestOfferService} from './physicalBestOffer/physicalBestOffer.service';
import {NgrsService} from './ngrs.service';
import {PrmGetItRequest} from './getItRequest/getItRequest.directive';
import {GetItRequestService} from './getItRequest/getItRequest.service'
import {FormBuilderService} from '../../../infra/formBuilder/formBuilder.service';
import {PrmNgrsBriefResultLine} from './ngrsBriefResultLine/ngrsBriefResultLine.directive';
import {PrmNgrsResultsButton} from './resultsButton/ngrsResultsButton.directive';
import {PrmBackToLibrarySearchButton} from './backToLibrarySearchButton/backToLibrarySearchButton.directive';
import {PrmBriefResultDeliveryOptionLink} from './ngrsBriefResultLine/briefResultDeliveryOptionLink/briefResultDeliveryOptionLink.directive';
import {PrmBriefResultPhysicalBestOffer} from './ngrsBriefResultLine/briefResultPhysicalBestOffer/briefResultPhysicalBestOffer.directive';


@NgModule({
    declarations: [
        PrmServicePhysicalBestOffer ,
        PrmServiceNoOfferFound,
        PrmServiceNgrs,
        PrmGetItRequest,      
        PrmServiceNgrs,
        PrmNgrsResultsButton,
        PrmBackToLibrarySearchButton,
        PrmNgrsBriefResultLine,
        PrmBriefResultDeliveryOptionLink,
        PrmBriefResultPhysicalBestOffer     
    ],
    providers: [
        PhysicalBestOfferService,
        NgrsService,
        GetItRequestService,
        FormBuilderService
    ],
    imports:[
        
    ]
})
export class NgrsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrs.module.ts